import {environment} from "../../../environments/environment";

function getFileFromBlob(blobPart, fileName, contentType) {
  if (!fileName || !contentType) {
    return;
  }

  const blob = new Blob([blobPart], {type: contentType});
  const file = new File([blob], fileName);

  return file;
}

function downloadFile(file) {
  const fileName = file.name;

  // For IE
  if (navigator.appVersion.toString().indexOf('.NET') > 0) {
    window.navigator.msSaveOrOpenBlob(file, fileName);
  } else {
    const link = document.createElement('a');

    link.style.display = 'none';
    link.href = window.URL.createObjectURL(file);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    // For Firefox, we need to postpone the removal of the link
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      link.remove();
    }, 0)
  }
}

(function () {

  'use strict';

  angular.module('gov.services')

    .factory('exportService', ['$http', 'attachmentService', '$mdToast', function ($http, attachmentService, $mdToast) {

      var pollUrl = environment.apiUrl + '/ReportPilot/api/Report/poll'
      var service = {};
      var timers = {};

      var startTimer = function (name, interval, callback) {
        // Stop the timer if its already running, no-op if not running
        stopTimer(name);

        timers[name] = setInterval(function () {
          callback();
        }, interval);

        // Fire right away, interval will fire again in specified interval
        callback();
      }

      var stopTimer = function (name) {
        var timer = timers[name];
        if (timer) {
          clearInterval(timer);
          delete timers[name];
        }
      }


      let getReport = function (data) {
        $http({
          method: 'POST',
          url: environment.apiUrl + '/ReportPilot/api/Report/export',
          data,
          responseType: 'blob'
        }).then(function (response) {
          if (data.export?.resourceFileExtension && data.request?.baseFileName && data.request?.contentType) {
            const fileName = `${data.request?.baseFileName}${data.export.resourceFileExtension}`;

            downloadFile(getFileFromBlob(response.data, fileName, data.request?.contentType));
          }
        });
      }

      service.pollExport = function (url, queryParams) {
        $mdToast.show(
          $mdToast
            .simple()
            .content('The extract of the report has started, it will be downloaded in a few seconds...')
            .position('top right')
            .hideDelay(10000)
            .action('OK')
            .theme('primary')
        );
        $http({
          url: url,
          method: 'GET',
          params: queryParams
        })
          .then(function (response) {
            startTimer(response.data.exportId, 10000, function () {
              $http.post(pollUrl, {
                ...response.data
              }).then(function (resp) {
                if (resp?.data?.export?.status === 'Succeeded') {
                  stopTimer(response.data.exportId);
                  getReport(resp?.data);
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .content('The extract of the report is finished, download in progress')
                      .position('top right')
                      .hideDelay(5000)
                      .action('OK')
                      .theme('primary')
                  );
                } else if (resp?.data?.export?.status === 'Failed' || resp?.data?.export?.status === 'Undefined') {
                  stopTimer(response.data.exportId);
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .content('The extract of the report failed')
                      .position('top right')
                      .hideDelay(5000)
                      .action('OK')
                      .theme('danger')
                  );
                }
              });
            })
          });
      };
      return service;

    }]);

})();
